import { Injectable } from "@angular/core";

@Injectable()
export class ConstantForOpenDiaog {

    //CashRegister
    readonly confirmationDialogSinlgeMsg_Height: string = '100px';
    readonly confirmationDialogSinlgeMsg_Width: string = '75%';

    readonly confirmationDialogMsg_Height: string = '117px';
    readonly confirmationDialoMsg_Width: string = '75%';

    readonly multipleTransactionDialog_Height: string = '81%';
    readonly multipleTransactionDialog_Width: string = '95%';
    readonly multipleTransactionDialog_MaxWidth: string = '95vw';

    readonly customerDialog_maxWidth: string = '90%';
    readonly customerDialog_Width: string = '90%';

    readonly productDetailsDialog_Width: string = '90%';
    readonly productDetailsDialog_MaxWidth: string = '90%';
    readonly productDetailsDialog_Height: string = '400px';

    readonly printTokenDialog_MaxHeight: string = '400px';
    readonly printTokenDialog_Width: string = '600px';

    readonly serveByDialog_MaxWidth: string = '90%';
    readonly serveByDialog_Width: string = '90%';
    readonly serveByDialog_Height: string = '57%';

    readonly invoicePreviewDialog_Height: string = '90%';

    readonly offerDialog_MaxWidth: string = '90%';
    readonly offerDialog_Width: string = '90%';
    readonly offerDialog_Height: string = '325px';

    readonly advanceSearchDialog_Width: string = '80%';
    readonly advanceSearchDialog_Height: string = '300px';

    readonly customerDeliveryDialog_MaxWidth: string = '90%';
    readonly customerDeliveryDialog_Width: string = '90%';
    readonly customerDeliveryDialog_Height: string = '515px';


    //Pos
    readonly billStatusDialog_Width: string = '80%';
    readonly billStatusDialog_Height: string = '385px';

    //Customer
    readonly mobileNumberVerificationDialog_Width: string = '270px';
    readonly mobileNumberVerificationDialog_Height: string = '145px';

}
